<template>
    <div class="category-page page my-container">
        <h2 class="header">
            {{ entryName }}
        </h2>

        <div class="category-list">
            <NuxtLink
                :to="localePath(el.type === 'group' ? `/catalog/${route.params.type}/${route.params.id}/group/${el.id}` : `/catalog/${route.params.type}/${route.params.id}/product/${el.id}`)"
                class="category" v-for="(el, i) in entryData" :key="el.id" data-aos="fade-up" data-aos-once="true"
                :data-aos-delay="100 * i">
                <div class="img-wrp">
                    <img :src="el.image" :alt="el.slug">
                </div>
                <span class="name">
                    {{ el.title?.[locale] || el.title }}
                </span>
            </NuxtLink>
        </div>
    </div>
</template>

<script setup>
const { locale, t } = useI18n()
const localePath = useLocalePath()
const rc = useRuntimeConfig();
const route = useRoute()
const res = await Promise.all([
    $fetch(rc.public.api + `/api/product/products-and-groups`, {
        query: {
            [`filters[${route.params.type}_id]`]: route.params.id
        }
    }),
    $fetch(rc.public.api + `/api/${route.params.type}/${route.params.id}`)
])
const entryData = ref(
    res[0].data.list
)
const entry = ref(
    res[1].data
)
const entryName = computed(() => {
    const lang = locale.value;
    if (entry.value.name?.[lang]) return entry.value.name?.[lang]
    return entry.value.name
})
</script>